export default __webpack_public_path__ + "static/google-play-badge-f902960a94878ee0da671fc4d3dbc8c0.png";